import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import { Icon } from './Icon';
import { Text } from './Typography';

// Single binary control. For "I agree", "Receive updates", per-row toggles.
// For lists of options where the user picks one or many, reach for
// `<RadioGroup>` or `<CheckboxGroup>` instead.

const CHECKBOX_ROOT_CLASSNAME = 'tw-peer tw-h-4 tw-w-4 tw-shrink-0 tw-rounded-sm tw-border tw-border-primary tw-ring-offset-background focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-bg-primary data-[state=checked]:tw-text-primary-foreground';

const Checkbox = React.forwardRef(
    ({ className: _className, style: _style, id, label, ...props }, ref) => (
        <div className="tw-flex tw-select-none tw-items-center tw-gap-2">
            <CheckboxPrimitive.Root
                id={id}
                ref={ref}
                className={CHECKBOX_ROOT_CLASSNAME}
                {...props}
            >
                <CheckboxPrimitive.Indicator className="tw-flex tw-items-center tw-justify-center tw-text-current">
                    <Icon icon="check" size="small" tone="inherit" />
                </CheckboxPrimitive.Indicator>
            </CheckboxPrimitive.Root>
            {label !== undefined ? (
                <label htmlFor={id} className="tw-cursor-pointer tw-select-none">
                    <Text variant="body">{label}</Text>
                </label>
            ) : null}
        </div>
    )
);

Checkbox.displayName = 'Checkbox';

export { Checkbox };
